module.exports = __webpack_public_path__ + "static/img/winter_dangseng.91f52a4f.png";